import styled from "styled-components";
const LogInFormStyle = styled.form`
  display: flex;
  flex-direction: column;
  .heading {
    align-self: center;
  }
  padding: 5px;
`;
export default LogInFormStyle;
